import { inject, injectable } from 'inversify'
import {
  FetchArticleUseCaseInput,
  FetchArticleUseCaseOutput,
  IAppErrorFactory,
  IArticlesService,
  IFetchArticleUseCase,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class FetchArticleInteractor implements IFetchArticleUseCase {
  @inject(symbols.IArticlesService) private articleService: IArticlesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: FetchArticleUseCaseInput): Promise<FetchArticleUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      const article = await this.articleService.fetchArticle(input.slug)
      output.article = article
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): FetchArticleUseCaseOutput {
    return {
      article: null,
      error: null,
    }
  }
}
